import type { Subscription } from "@/features/subscription/types";
import { functions } from "@/libs/firebase";
import { httpsCallable } from "firebase/functions";
import { useEffect, useMemo, useState } from "react";

type ActiveStripeSubscriptionResponse = {
	subscription: {
		id: string;
		currentPeriodEnd: number;
		cancelAtPeriodEnd: boolean;
	} | null;
};

export function useActiveSubscription(userId: string | undefined) {
	const [activeSubscription, setActiveSubscription] = useState<Subscription>();

	useEffect(() => {
		if (!userId) {
			setActiveSubscription(undefined);
			return;
		}

		let cancelled = false;
		const callable = httpsCallable<void, ActiveStripeSubscriptionResponse>(
			functions,
			"activeStripeSubscription",
		);

		callable()
			.then((result) => {
				if (cancelled) return;
				const subscription = result.data.subscription;
				if (!subscription) {
					setActiveSubscription(undefined);
					return;
				}

				setActiveSubscription({
					id: subscription.id,
					currentPeriodEnd: new Date(subscription.currentPeriodEnd * 1000),
					cancelAtPeriodEnd: subscription.cancelAtPeriodEnd,
				});
			})
			.catch(() => {
				if (!cancelled) setActiveSubscription(undefined);
			});

		return () => {
			cancelled = true;
		};
	}, [userId]);

	return useMemo(
		() => ({
			activeSubscription,
		}),
		[activeSubscription],
	);
}
